import type { SvgIconProps } from "@mui/material";
import { styled } from "@mui/material";
import { forwardRef } from "react";

import svg from "./candidate-objective-with-baseline-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

const CandidateObjectiveWithMinBaselineIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.grey[300]
);
const CandidateObjectiveWithMaxBaselineIcon = styled(
  CandidateObjectiveWithMinBaselineIcon
)({
  transform: "scale(-1, 1)",
});

export const CandidateObjectiveWithBaselineIcon = forwardRef(function (
  {
    objectiveType = "ScalarMax",
    ...props
  }: SvgIconProps & { objectiveType?: "ScalarMax" | "ScalarMin" },
  ref: React.Ref<SVGSVGElement>
) {
  return objectiveType === "ScalarMax" ? (
    <CandidateObjectiveWithMinBaselineIcon {...props} ref={ref} />
  ) : (
    <CandidateObjectiveWithMaxBaselineIcon {...props} ref={ref} />
  );
});

export default CandidateObjectiveWithBaselineIcon;
